import { computed } from 'vue';
import { usePolicy } from 'dashboard/composables/usePolicy';

export function useCompanyPermissions() {
  const { checkPermissions } = usePolicy();
  const canManageCompany = computed(() =>
    checkPermissions(['administrator', 'agent', 'contact_manage'])
  );
  return { canManageCompany };
}
